// import Main from '@/view/main'

export default {
  path: 'pm',
  meta: {
    title: '商品管理'
  },
  component: () => import('@/components/parent-view'),
  name: 'pm',
  children: [
    {
      path: '',
      meta: {
        title: '商品列表'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: 'list',
          meta: {
            title: '商品列表',
            ignoreBreadCrumb: true,
            notCache: false
          },
          name: 'self-pm-list',
          component: () => import('@/view/v5/pm/index.vue')
        },
        {
          meta: {
            title: '商品详情',
            hideInTabBar: true,
            detail: true
          },
          path: 'detail/:id',
          component: () => import('@/view/v5/pm/detail.vue')
        },
        {
          meta: {
            title: '新增商品',
            hideInTabBar: true
          },
          path: 'add',
          component: () => import('@/view/v5/pm/detail.vue')
        },
        {
          meta: {
            title: '商品编辑',
            hideInTabBar: true
          },
          path: 'edit/:id',
          component: () => import('@/view/v5/pm/detail.vue')
        },
        {
          meta: {
            title: '商品快速编辑',
            hideInTabBar: true
          },
          path: 'quickEdit/:id',
          component: () => import('@/view/v5/pm/quickEdit.vue')
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/v5/pm.js